import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {UnmarkedAsDuplicateEvent$key} from './__generated__/UnmarkedAsDuplicateEvent.graphql'
import {TimelineRow} from './row/TimelineRow'

type UnmarkedAsDuplicateEventProps = {
  queryRef: UnmarkedAsDuplicateEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function UnmarkedAsDuplicateEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: UnmarkedAsDuplicateEventProps): JSX.Element {
  const {actor, createdAt, canonical, databaseId} = useFragment(
    graphql`
      fragment UnmarkedAsDuplicateEvent on UnmarkedAsDuplicateEvent {
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        createdAt
        canonical {
          ... on Issue {
            url
            number
          }
          ... on PullRequest {
            url
            number
          }
        }
        databaseId
      }
    `,
    queryRef,
  )
  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
    >
      <>
        {LABELS.timeline.unmarkedAsDuplicate}
        <Link href={canonical?.url} sx={{color: 'accent.fg', mx: 1}}>
          #{canonical?.number}
        </Link>
      </>
    </TimelineRow>
  )
}

try{ UnmarkedAsDuplicateEvent.displayName ||= 'UnmarkedAsDuplicateEvent' } catch {}